export default __webpack_public_path__ + "static/media/Arrow.f6967666.svg";